export default "__VITE_ASSET__caa32f77__"